import WeatherInfo from './weather-info'

export default class WeatherForecast {
  constructor() {
    this.durationHours = 0 // 何時間おきの予報か
    this.weathers = []
  }

  static fromOpenWeatherMapResult(apiResult) {
    let forecast = new WeatherForecast()
    const list = apiResult.list
    for (let i = 0; i < list.length; i++) {
      const result = list[i]
      const w = WeatherInfo.fromOpenWeatherMapResult(result)
      forecast.weathers.push(w)
    }

    forecast.durationHours = 0
    return forecast
  }

  getListSkipBy(skipCount, maxCount = 0) {
    let list = []
    for (let i = 0; i < this.weathers.length; i++) {
      list.push(this.weathers[i])
      i = i + skipCount
      if (maxCount - 1 < list.length) {
        return list
      }
    }
    return list
  }
}
